import { createApp } from 'vue'
import router from '@/router'
import { createPinia } from '@core/stores/pinia'
import { useAuthStore } from '@core/stores/auth'
import filters from '@core/filters'
import App from '@/App.vue'
import '@/assets/index.css'
import '@core/global'
import '@core/window'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Restore session on app load
const authStore = useAuthStore()
authStore.restoreSession()

app.config.globalProperties.$baseUrl = window.location.origin;
app.config.globalProperties.$currentHost = window.location.host;
app.config.globalProperties.$prefixUrl = window.$prefixUrl;
app.config.globalProperties.$moduleName = window.$moduleName;
app.config.globalProperties.$isDesktop = false;
app.config.globalProperties.$filter = filters;

app.mount('#app')

